import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { ObjectivePartsValidationSchema } from "../schemas/objectiveParts.schema";
import { getRailsUpdate } from "@/common/utils/getRailsUpdate";
import { MaintenanceObjectivePartsData } from "../types/MaintenanceObjectiveParts.type";
import { mapToDeletion } from "@/common/utils/railsHelpers";

interface UseUpdateObjectivePartProps {
  id?: string;
  objectivePart?: MaintenanceObjectivePartsData;
  onSuccess?: () => void
  onError?: (error: any) => void
}

const useUpdateObjectivePart = ({ id, objectivePart, onSuccess, onError }: UseUpdateObjectivePartProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updateMaintenanceObjectivePart', id],
    mutationFn: (data: ObjectivePartsValidationSchema) => {
      const payload = {
        objective_part: {
          display_name: data.display_name,
          system_parts_attributes: getRailsUpdate(
            objectivePart?.system_parts || [],
            data.system_parts_attributes || [],
            (x) => x.system.id,
            (y) => y.value,
            mapToDeletion,
            (z) => ({ system_id: z.value }),
          ),
        }
      }

      return privateAxios.put(`/maintenance/objective_parts/${id}`, payload);
    },
    onSuccess,
    onError,
  });
}

export default useUpdateObjectivePart;
